var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
var MARK = '__rc_react_root__';
var createRoot;
var legacyRender;
var legacyUnmount;
var initialized = false;
function ensureReactDOM() {
    return __awaiter(this, void 0, void 0, function () {
        var version, mainVersion, client, legacy, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (initialized)
                        return [2 /*return*/];
                    initialized = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    version = React.version || '';
                    mainVersion = parseInt(version.split('.')[0], 10);
                    if (!(mainVersion >= 18)) return [3 /*break*/, 3];
                    return [4 /*yield*/, import('react-dom/client')];
                case 2:
                    client = _a.sent();
                    createRoot = client.createRoot;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, import('react-dom')];
                case 4:
                    legacy = _a.sent();
                    legacyRender = legacy.render;
                    legacyUnmount = legacy.unmountComponentAtNode;
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    console.warn('[react-render] Failed to load ReactDOM API:', e_1);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
// ========== 渲染 ==========
function modernRender(node, container) {
    if (!container[MARK]) {
        container[MARK] = createRoot(container);
    }
    container[MARK].render(node);
}
function fallbackLegacyRender(node, container) {
    if (!legacyRender)
        throw new Error('ReactDOM.render not available');
    legacyRender(node, container);
}
export function render(node, container) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureReactDOM()];
                case 1:
                    _a.sent();
                    if (createRoot)
                        modernRender(node, container);
                    else
                        fallbackLegacyRender(node, container);
                    return [2 /*return*/];
            }
        });
    });
}
// ========== 卸载 ==========
function fallbackLegacyUnmount(container) {
    if (!legacyUnmount)
        throw new Error('ReactDOM.unmountComponentAtNode not available');
    legacyUnmount(container);
}
function modernUnmount(container) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            (_b = (_a = container[MARK]) === null || _a === void 0 ? void 0 : _a.unmount) === null || _b === void 0 ? void 0 : _b.call(_a);
            delete container[MARK];
            return [2 /*return*/];
        });
    });
}
export function unmount(container) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ensureReactDOM()];
                case 1:
                    _a.sent();
                    if (createRoot)
                        return [2 /*return*/, modernUnmount(container)];
                    else
                        return [2 /*return*/, fallbackLegacyUnmount(container)];
                    return [2 /*return*/];
            }
        });
    });
}
